// gather all validation functions for importing elsewhere

import addErrorsToFields from './addErrorsToFields';
import alphaNumericValidator from './alphaNumericValidator';
import checkIfFieldsHaveErrors from './checkIfFieldsHaveErrors';
import clearFieldValues from './clearFieldValues';
import emailValidator from './emailValidator';
import lengthValidator from './lengthValidator';
import telValidator from './telValidator';
import validateFields from './validateFields';

const validators = {
  alphaNumericValidator,
  emailValidator,
  lengthValidator,
  telValidator,
};
const validationFunctions = {
  addErrorsToFields,
  checkIfFieldsHaveErrors,
  clearFieldValues,
  validateFields,
};

export { validators, validationFunctions };



// WEBPACK FOOTER //
// ./scripts/util/validation/index.js